export const initializePaystackTransactionMutation = (payload) => {
    const mutation = `
      mutation {
        initializeTransaction(
            amount: ${payload.amount},
            paymentItem: "${payload.paymentItem}",
        ) {
          accessCode
          error
          }
      }
      `;
    return mutation;
  };
  export const cancelCardSubscriptionMutation = () => {
    const mutation = `
      mutation{
          cancelCardSubscription{
              message
              success
          }
      }
      `;
    return mutation;
  };
  